import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'validate.js';

const FROM_GOOD_DOG_ITEMS = [
  'Lifetime support from Good Dog’s Care Team',
  '10% lifetime discount on Figo pet insurance',
  'Puppy Training Program & private community'
];

const DEFAULT_HEALTH_PRACTICES = [
  'Vet check',
  'First round of shots and deworming'
];

const HEALTH_PRACTICE_EXTRAS = ['Microchip', 'Vet records', 'Vaccinations'];

export default function useIncludedItems() {
  const { breederPuppyExtras = [], breederTrainingPrograms } = useSelector(
    ({ server }) => server
  );

  return useMemo(() => {
    const { healthPractices, puppyExtras } = breederPuppyExtras.reduce(
      (acc, extra) => {
        if (HEALTH_PRACTICE_EXTRAS.includes(extra)) {
          acc.healthPractices.push(extra);
        } else {
          acc.puppyExtras.push(extra);
        }

        return acc;
      },
      {
        healthPractices: [...DEFAULT_HEALTH_PRACTICES],
        puppyExtras: []
      }
    );

    return [
      !isEmpty(FROM_GOOD_DOG_ITEMS) && {
        id: 'hats-included-from-good-dog',
        title: 'From Good Dog',
        items: FROM_GOOD_DOG_ITEMS,
        iconName: 'fetch-pets-heart'
      },
      !isEmpty(breederTrainingPrograms) && {
        id: 'whats-included-enrichment-socialization',
        title: 'Enrichment & socialization',
        items: breederTrainingPrograms,
        iconName: 'fetch-cat-dog'
      },
      !isEmpty(healthPractices) && {
        id: 'whats-included-puppy-health-practices',
        title: 'Puppy health practices',
        items: healthPractices,
        iconName: 'fetch-health-verified'
      },
      !isEmpty(puppyExtras) && {
        id: 'whats-included-extras',
        title: 'Extras',
        items: puppyExtras,
        iconName: 'fetch-gift'
      }
    ].filter(Boolean);
  }, []);
}
